module.exports = __webpack_public_path__ + "static/media/nyc.c5ad9dc1.geojson";